/*
 * Tabs
 *
 * What tab strips need beyond CSS, in one script for the layouts
 * (BundleConfig.TabsJs). Both parts bind themselves on load, including to strips
 * added later, and neither needs jQuery:
 *
 *   tabScroll.js   overflow arrows for every .mt-toggle and .mt-tabscroll strip
 *   keyboard.js    keyboard support and selection state for @Html.Tabs (js-tabs)
 */
import TabScroll from './tabScroll';
import TabKeyboard from './keyboard';

export default { TabScroll, select: TabKeyboard.select };
